"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var setOcUserAgent = function (OCClient, ocUserAgent) {
    var version = require('../../package.json').version; // eslint-disable-line @typescript-eslint/no-var-requires
    var userAgent = "omnichannel-chat-sdk/" + version;
    if (!OCClient.ocUserAgent) {
        OCClient.ocUserAgent = [];
    }
    OCClient.ocUserAgent = __spreadArrays([userAgent], OCClient.ocUserAgent);
    if (ocUserAgent) {
        OCClient.ocUserAgent = __spreadArrays(ocUserAgent, OCClient.ocUserAgent);
    }
};
exports.default = setOcUserAgent;
//# sourceMappingURL=setOcUserAgent.js.map